import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'

/** Uses betRef to trim a coupon with multiple bets into a single bet coupon */
export const getSingularBetCouponFromKambiCoupon = (
  historyCoupon: KambiHistoryCoupon,
  bet: KambiHistoryCoupon['bets'][0]
) => {
  if (historyCoupon.bets.length === 1) return historyCoupon

  const couponRows = historyCoupon.couponRows.filter(({ index }) =>
    bet.couponRowIndexes.includes(index)
  )

  const outcomes = historyCoupon.outcomes.filter(({ outcomeId }) =>
    couponRows.some(couponRow => couponRow.outcomeId === outcomeId)
  )

  const events = historyCoupon.events.filter(({ eventId }) =>
    outcomes.some(outcome => outcome.eventId === eventId)
  )

  const betOffers = historyCoupon.betOffers.filter(({ betOfferId }) =>
    outcomes.some(outcome => outcome.betOfferId === betOfferId)
  )

  return {
    ...historyCoupon,
    bets: [bet],
    couponRows,
    outcomes,
    events,
    betOffers,
  }
}
